import PropTypes from 'prop-types';
import React from 'react';
import { truncateWithEllipsis } from '../../../utilities/ui_utilities';
import VisibilityPixel, {
    EmitMetric,
} from '../../Analytics/VisibilityPixel/VisibilityPixel';
import Button from '../../Input/Button/Button';
import { buildImagePath } from '../../JobComponents/Company/Image/logo';
import './InlineAd.scss';

export default class InlineAd extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * Company Id - REQUIRED
         * */
        companyId: PropTypes.number.isRequired,
        /**
         * url for ad - REQUIRED
         * */
        clickThroughUrl: PropTypes.string.isRequired,
        /**
         * logo for company ad - REQUIRED
         * */
        companyLogo: PropTypes.string.isRequired,
        /**
         * company name - REQUIRED
         * */
        companyName: PropTypes.string.isRequired,
        /**
         * location for user
         * */
        userLocation: PropTypes.string,
        /**
         * job location
         * */
        jobLocation: PropTypes.string,
        /**
         * optional classname
         * */
        className: PropTypes.string,
        /**
         * AB testing parameter
         * */
        headline: PropTypes.string,
        testFlag: PropTypes.oneOf([
            'near-you-text',
            'near-your-location-text',
            'is-hiring-no-location',
            'in-company-location-text',
        ]),
    };

    static defaultProps = {
        companyAdTextType: 'A',
    };

    componentDidMount() {
        EmitMetric({
            misc_event_type: 'editorial-inline-company-ad',
            impression: 1,
            test_flag: this.props.testFlag,
            company_id: [this.props.companyId],
        });
    }

    handleClick = () => {
        VisibilityPixel.setLastActionParams(
            'article-incontent-ad',
            this.props.companyName
        );
        EmitMetric({
            misc_event_type: 'editorial-inline-company-ad',
            click: 1,
            test_flag: this.props.testFlag,
            company_id: [this.props.companyId],
        });
        return true;
    };

    render() {
        const companyLogo = buildImagePath(
            this.props.companyLogo,
            'small-lPad'
        );

        return (
            <div
                className={`component-CompanyAds-InlineAd d-flex align-items-center justify-content-center ${this.props.className}`}
            >
                <a
                    className="border-box d-flex flex-column align-items-center"
                    href={this.props.clickThroughUrl}
                    onClick={this.handleClick}
                >
                    <img className="companyAd-company-logo" src={companyLogo} />
                    <div className="description-label">
                        Companies Women Love
                    </div>
                    <div className="company-inlineAd-ad-text">
                        {truncateWithEllipsis(this.props.headline, 80)}
                    </div>
                    <div className="company-inlineAd-call-to-action-button-div">
                        <Button type={'solid'} value={'See jobs'} />
                    </div>
                </a>
            </div>
        );
    }
}
